export const RoleType = Object.freeze({
  ROLE_ANONYMOUS: "ROLE_ANONYMOUS",
  ROLE_MEMBER: "ROLE_MEMBER",
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_ASSET: "ROLE_ASSET"
});
